import { LoadingOverlay } from '@eventbrite/eds-loading-overlay';
import React, { FunctionComponent } from 'react';
import { getLoadingOverlayStyle } from '../../utils/rebrand';

export const LoadingPage: FunctionComponent<{
    isAppRebrandActive: boolean;
    isInitialPath: boolean;
}> = ({ isAppRebrandActive }) => (
    <LoadingOverlay
        isShown={true}
        style={getLoadingOverlayStyle(isAppRebrandActive)}
        isAppRebrandActive={isAppRebrandActive}
    />
);

export default LoadingPage;
